import { render, staticRenderFns } from "./KonvaCampaignSidebar.vue?vue&type=template&id=2fceadba&scoped=true"
import script from "./KonvaCampaignSidebar.vue?vue&type=script&lang=js"
export * from "./KonvaCampaignSidebar.vue?vue&type=script&lang=js"
import style0 from "./KonvaCampaignSidebar.vue?vue&type=style&index=0&id=2fceadba&prod&scoped=true&lang=scss"
import style1 from "./KonvaCampaignSidebar.vue?vue&type=style&index=1&id=2fceadba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fceadba",
  null
  
)

export default component.exports